import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { RootState } from '../../../types/common.types';

import { useExternalRegistrationApi } from '../../../api/external-registration/useExternalRegistrationApi';

import Registration from '../../../components/screens/auth/registration/Registration';

const RegistrationContainer = () => {
  const { programmes } = useSelector((state: RootState) => state.registration);

  const [searchParams] = useSearchParams();

  const navigate = useNavigate();

  const { findActiveProgrammes } = useExternalRegistrationApi();

  useEffect(() => {
    findActiveProgrammes();
  }, [findActiveProgrammes]);

  const availableProgrammes = useMemo(() => {
    if (!programmes) return [];

    return programmes.filter((programme) => !!programme.hasRegistrationRequirements);
  }, [programmes]);

  const navigateToProgramme = (externalReference: string) => {
    const theme = searchParams.get('theme');
    if (theme) {
      navigate(`${externalReference}?theme=${theme}`);
    } else {
      navigate(externalReference);
    }
  };

  return <Registration programmes={availableProgrammes} navigateToProgramme={navigateToProgramme} />;
};

export default RegistrationContainer;
